module.exports = __webpack_public_path__ + "065c97730ceb9ef158781adebd4d4612.svg";